<button (click)="openRightPanel(tempRef)" color="primary" mat-button>Registrati</button>
<ng-template #tempRef>
  <app-sidenav [title]="'registrati'">
    <form [formGroup]="signupForm">
      <div class="col-12 p-0">
        <app-input-text [form]="signupForm" icon="person" label="Username" name="username"
                        placeholder="m.rossi"></app-input-text>
      </div>
      <div class="col-12 p-0">
        <app-input-text [form]="signupForm" icon="person" label="E-mail" name="email"
                        placeholder="m.rossi@mail.to"></app-input-text>
      </div>
      <div class="col-12 p-0">
        <app-input-password [form]="signupForm" icon="password" label="Inserisci la tua password"
                            name="password"></app-input-password>
      </div>
      <div class="col-12 p-0">
        <app-input-password [form]="signupForm" icon="password" label="Conferma la tua password"
                            name="passwordMatch"></app-input-password>
      </div>
    </form>
    <div footer>
      <div class="flex justify-content-center pb-2">
        <app-primary-button (click)="onSignupClick()" [disabled]="!signupForm.valid"
                            label="Registrati"></app-primary-button>
      </div>
    </div>
  </app-sidenav>
</ng-template>
